import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';

class SolviyaQuantityOffer extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.form = this.closest('form');
    this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '{}');
    this.addEventListener('click', this.choose, { signal });
    this.form?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.sync, { signal });
    this.form?.addEventListener('change', this.sync, { signal });
    const scope = this.closest('product-card') || this.closest('.shopify-section');
    scope?.addEventListener(StandardEvents.productSelect, this.variantChange, { signal });
    this.sync();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    this.form?.classList.remove('solviya-quantity-enhanced');
    cancelAnimationFrame(this.frame);
  }
  updatedCallback() { super.updatedCallback(); this.sync(); }
  variantChange = async (event) => {
    try {
      await event.promise;
      if (!this.isConnected) return;
      this.frame = requestAnimationFrame(() => this.sync());
    } catch { /* Native product form displays selection errors. */ }
  };
  choose = (event) => {
    const button = event.target instanceof Element ? event.target.closest('button[data-offer-quantity]') : null;
    if (!button || button.disabled) return;
    const selector = this.form?.querySelector('quantity-selector-component');
    selector?.setValue(button.dataset.offerQuantity);
    selector?.updateButtonStates();
    selector?.onQuantityChange();
    this.sync();
  };
  sync = () => {
    const id = this.form?.querySelector('input[name="id"]')?.value;
    const variant = this.variants?.[id];
    const quantity = this.form?.querySelector('input[name="quantity"]');
    if (!variant || !(quantity instanceof HTMLInputElement)) { this.hidden = true; return; }
    this.hidden = variant.min > 1 || variant.step > 1 || !variant.available;
    this.form?.classList.toggle('solviya-quantity-enhanced', !this.hidden);
    this.querySelector('[data-one-price]').innerHTML = variant.one;
    this.querySelector('[data-two-price]').innerHTML = variant.two;
    this.querySelector('[data-original-price]').innerHTML = variant.original;
    for (const radio of this.querySelectorAll('button[data-offer-quantity]')) {
      const n = Number(radio.dataset.offerQuantity);
      radio.setAttribute('aria-pressed', String(Number(quantity.value) === n));
      radio.disabled = quantity.disabled || (variant.max !== null && n > variant.max);
    }
  };
}
if (!customElements.get('solviya-quantity-offer')) customElements.define('solviya-quantity-offer', SolviyaQuantityOffer);
